import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { ConfirmProvider, ToastProvider } from "@/components";
import { useAuth } from "@/hooks";
import { AppRoutes } from "@/routes";

const SessionBootstrap = () => {
    const {
        isAuthenticated,
        onFetchUser,
    } = useAuth();

    useEffect(
        () => {
            if (isAuthenticated) onFetchUser();
        },
        [],
    );

    return null;
};

export const App = () => (
    <BrowserRouter>
        <ToastProvider>
            <ConfirmProvider>
                <SessionBootstrap />
                <AppRoutes />
            </ConfirmProvider>
        </ToastProvider>
    </BrowserRouter>
);
